import axios from 'axios'
const API_URL = `${process.env.REACT_APP_API_URL}`;
const CBEWSL_SITE = process.env.REACT_APP_SITE

export const getEvents = (callback) => {
    axios.get(`${API_URL}/api/events/get_all_events/${CBEWSL_SITE}`).then((response) => {
        callback(response.data)
    }).catch((error) => {
    
    });
}

export const addEvent = (data,callback) => {
    axios.post(`${API_URL}/api/events/save_activity`, data).then((response) => {
        callback(response.data)
    }).catch((error) => {
    
    });
}

export const deleteEvent = (data,callback) => {
    axios.post(`${API_URL}/api/events/delete_activity`, data).then((response) => {
        callback(response.data)
    }).catch((error) => {
    
    });
}

export const getNumberOfFiles = (folder, callback) => {
  const api_link = `${API_URL}/api/misc/get_files/${folder}`;
  axios
    .get(api_link)
    .then((response) => {
      if (response.data.status === true) {
        callback(response.data.data);
      }
    })
    .catch((error) => {
      console.error(error);
    });
};

export const uploadActivityImage = (formData, callback) => {
    axios
      .post(`${API_URL}/storage/activity_schedule`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        // handle the response
        console.log(response);
      })
      .catch((error) => {
        // handle errors
        console.log(error);
      });
  };
  